/**
 * This file is kept for backward compatibility and to avoid updating every import in the Web app.
 * All new analytics-related code should live in and be imported directly from "@punchup/analytics".
 */

export {
  UserEvents,
  HeaderEvents,
  NewsLetterEvents,
  BaseEmailEvents,
  OnboardingEvents,
  HealthCheckEvents,
  SouthpawEvents,
  SubscriptionEvents,
  ComedianLandingPageEvents,
  DashboardEvents,
  DashboardTourDatesEvents,
  DashboardMessagesEvents,
  VenueEvents,
  VenuesEvents,
  VenueManagerShowsEvents,
  VenueDashboardEvents,
  SpecialEvents,
  BundleEvents,
  VideoEvents,
  LibraryEvents,
  SearchEvents,
  SearchSurface,
  DiscoverEntrySource,
  UserSignupEvents,
  SpecialsCarouselEvents,
  SpecialPageEvents,
  ComedianCarouselEvents,
  GenericEvents,
  ContentNavEvents,
  NavbarEvents,
  ShowsNearbyEvents,
  ShareBarEvents,
  SuggestedComediansEvents,
  CheckoutEvents,
  PaymentEvents,
  GroupedShowsEvents,
  NotificationPreferencesEvents,
  EmailEvents,
  WebNotificationsEvents,
  FeedEvents,
  MerchEvents,
  PushNotificationEvents,
  PaidContentEvents,
  VenuePageEvents,
} from "@punchup/analytics";
